import { formatDate, formatReadTime } from '@/lib/utils';
import Image from 'next/image';
import Link from 'next/link';

export const FeaturedArticleCard = ({ blog }) => {
  return (
    <div className="border border-[#404040] rounded-[24px] w-full h-full overflow-hidden">
      {/* overlay link */}
      <Link href={`/blog/${blog.slug}`} className="z-10 absolute inset-0" />
      <div className="relative w-full h-[271px]">
        <Image
          src={`${process.env.NEXT_PUBLIC_API_URL}/assets/${blog?.banner}`}
          alt="Blog Banner"
          fill
          className="object-cover"
        />
      </div>
      <div className="flex flex-col px-4 py-6">
        <h3 className="font-instrument-serif text-[24px] text-white line-clamp-2 leading-7">
          {blog.name}
        </h3>
        {/* Below should be description */}
        <p className="mt-1 font-inter-tight text-[#999999] text-[16px] line-clamp-2">
          {blog.name}
        </p>

        <span className="opacity-60 my-6 border-[#1D464A] border-b w-full h-[1px]"></span>

        <div className="flex items-center gap-2 w-full">
          <span className="relative rounded-full w-[36px] h-[36px] overflow-hidden">
            <Image
              src={`${process.env.NEXT_PUBLIC_API_URL}/assets/${blog?.author_profile}`}
              alt=""
              fill
              className="object-cover"
            />
          </span>

          <span className="flex flex-col">
            <p className="font-instrument-serif text-[16px]">{blog.author}</p>
            <span className="flex items-center gap-2">
              <p className="font-inter-tight text-[#999999] text-[12px]">
                {formatDate(blog.published_date)}
              </p>
              <span className="bg-[#999999] rounded-full w-[6px] h-[6px]"></span>
              <p className="font-inter-tight text-[#999999] text-[12px]">
                {formatReadTime(blog.content_read_time)}
              </p>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};
